import { ValidationModel } from '../../../shared/models/validation-results/validation.model';
import { DisbursementSummaryModel } from './disbursement-summary.model';

export class DisbursementSummarySearchResultsModel extends ValidationModel {

    // Gets or sets the disbursement summaries
    public disbursementSummaries: DisbursementSummaryModel[];

    constructor(json: any) {
        super(json);
        json = this.getBody();

        if (json && json.disbursementSummaries && Array.isArray(json.disbursementSummaries)) {
            this.disbursementSummaries = new Array<DisbursementSummaryModel>();
            json.disbursementSummaries.forEach(item => {
                var disbursementSummary: DisbursementSummaryModel = new DisbursementSummaryModel(item);
                this.disbursementSummaries.push(disbursementSummary);
            });
        }
    }
}
